/**
 * Display-only Rial/Toman conversion. Storage, arithmetic, and API payloads
 * stay integer Rial (AGENTS.md §9). The only ÷10 in the product lives here.
 */
export const AMOUNT_DISPLAY_UNITS = ['rial', 'toman'];
/** 1 Toman = 10 Rial. Integer minor-unit scale, never a float. */
export const RIALS_PER_TOMAN = 10n;
export function isAmountDisplayUnit(value) {
    return value === 'rial' || value === 'toman';
}
/**
 * Converts an authoritative integer-Rial digit string into the integer to
 * show for `unit`. Toman is truncating integer division by 10 (no remainder
 * is rendered — the stored Rial is unchanged).
 */
export function rialDigitsToDisplayDigits(rialDigits, unit) {
    if (!/^-?\d+$/.test(rialDigits))
        return rialDigits;
    const amount = BigInt(rialDigits);
    if (unit === 'toman')
        return (amount / RIALS_PER_TOMAN).toString();
    return amount.toString();
}
/** fa-IR grouped digits for a stored Rial amount, in the requested unit. */
export function formatRialAmountFa(rialDigits, unit = 'rial', locale = 'fa-IR') {
    const digits = rialDigitsToDisplayDigits(rialDigits, unit);
    if (!/^-?\d+$/.test(digits))
        return rialDigits;
    return BigInt(digits).toLocaleString(locale);
}
export function amountDisplayUnitLabel(unit) {
    return unit === 'toman' ? 'تومان' : 'ریال';
}
//# sourceMappingURL=display.js.map